module.exports = __webpack_public_path__ + "img/carousel-3.a0053d08.png";